
<script>
	import Router, { location } from "svelte-spa-router";
	import Home from "./routes/Home.svelte";
	import Module from "./routes/Module.svelte";
    import Login from "./routes/Login.svelte";
    import Registration from "./routes/Registration.svelte";
    import Billing from "./routes/Billing.svelte";
	import PaymentSuccessful from "./routes/PaymentSuccessful.svelte";
	import Guide from "./routes/Guide.svelte";
	import Manga_Translator from "./routes/Manga_Translator.svelte";
	import Logout from "./routes/Logout.svelte";


	let routes = {
		"/": Home,
		"/Login": Login,
		"/Registration": Registration,
		"/Module": Module,
		"/Billing": Billing,
		"/PaymentSuccessful": PaymentSuccessful,
		"/Manga_Translator": Manga_Translator,
		"/Guide": Guide,
		"/Logout": Logout
	}

	import { AccountInfoStore } from "./stores";

	let accountInfo = {}
	AccountInfoStore.subscribe((data) => {accountInfo = data})

	if (localStorage.getItem("sugoi_username") == "" || localStorage.getItem("sugoi_username") == null) {
		let doNothing = "user logged out"
	}
	else {
		accountInfo.username = localStorage.getItem("sugoi_username")
		accountInfo.password = localStorage.getItem("sugoi_password")
		accountInfo.loginStatus = true
		accountInfo.coins = Number(localStorage.getItem("sugoi_coins"))
		accountInfo.accessToken = localStorage.getItem("sugoi_accessToken")
		accountInfo["patreon_email"] = localStorage.getItem("patreon_email")
		accountInfo["patreon_username"] = localStorage.getItem("patreon_username")

		AccountInfoStore.set(accountInfo)
	}

	$: accountInfo.loginStatus, console.log(accountInfo.loginStatus)

	// Function to check if a link is active
	function isActive(path) {
		// Handle home route specially
		if (path === '/' && $location === '') {
			return true;
		}
		// For other routes, check if the location starts with the path
		return path !== '/' && $location === path.replace('#', '');
	}
</script>

<nav class="top-menu">
	<div class="menu-container">
		<div class="logo">
			<a href="/"><img src="inu_icon.png" alt="Shiba Inu" class="logo-icon" /> Sugoi Toolkit</a>
		</div>
		<div class="menu-items">
			{#if accountInfo.loginStatus === true}
				<a href="/" class="menu-link {isActive('/') ? 'active' : ''}">Home</a>
				<a href="#/Billing" class="menu-link {isActive('#/Billing') ? 'active' : ''}">Billing</a>
				<a href="#/Manga_Translator" class="menu-link {isActive('#/Manga_Translator') ? 'active' : ''}">Manga Translator</a>
				<a href="#/Guide" class="menu-link {isActive('#/Guide') ? 'active' : ''}">Guide</a>
				<a href="#/Logout" class="menu-link {isActive('#/Logout') ? 'active' : ''}">Logout</a>
			{:else}
				<a href="/" class="menu-link {isActive('/') ? 'active' : ''}">Home</a>
				<a href="#/Login" class="menu-link {isActive('#/Login') ? 'active' : ''}">Login</a>
				<a href="#/Registration" class="menu-link {isActive('#/Registration') ? 'active' : ''}">Registration</a>
				<a href="#/Billing" class="menu-link {isActive('#/Billing') ? 'active' : ''}">Billing</a>
				<a href="#/Manga_Translator" class="menu-link {isActive('#/Manga_Translator') ? 'active' : ''}">Manga Translator</a>
				<a href="#/Guide" class="menu-link {isActive('#/Guide') ? 'active' : ''}">Guide</a>
			{/if}
			<!-- <a href="#/PaymentSuccessful" class="menu-link">PaymentSuccessful</a> -->
		</div>
	</div>
</nav>

<main>
	<Router {routes}/>
</main>

<style>
	:global(body) {
		margin: 0;
		padding: 0;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
	}

	.top-menu {
		background-color: #2c3e50;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		position: sticky;
		top: 0;
		z-index: 100;
		width: 100%;
	}

	.menu-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.8rem 1.5rem;
		max-width: 1200px;
		margin: 0 auto;
	}

	.logo a {
		font-size: 1.5rem;
		font-weight: bold;
		color: #ecf0f1;
		text-decoration: none;
		transition: color 0.3s ease;
		display: flex;
		align-items: center;
		gap: 0.5rem;
	}
	
	.logo-icon {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		object-fit: cover;
		transition: transform 0.3s ease;
	}
	
	.logo a:hover .logo-icon {
		transform: rotate(10deg);
	}

	.logo a:hover {
		color: #3498db;
	}

	.menu-items {
		display: flex;
		gap: 1.5rem;
		flex-wrap: wrap;
	}
	
	.menu-items a {
		animation: fadeIn 0.5s ease-in-out;
	}
	
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.menu-link {
		font-size: 1rem;
		color: #ecf0f1;
		text-decoration: none;
		padding: 0.5rem 0.75rem;
		border-radius: 4px;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
	}
	
	.menu-link::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 50%;
		width: 0;
		height: 2px;
		background-color: #3498db;
		transition: all 0.3s ease;
		transform: translateX(-50%);
	}
	
	.menu-link:hover::after {
		width: 80%;
	}

	.menu-link:hover {
		background-color: #3498db;
		color: white;
	}

	.menu-link.active {
		background-color: #3498db;
		color: white;
		font-weight: 500;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	
	.menu-link.active::after {
		width: 90%;
		background-color: #fff;
		height: 3px;
	}

	@media (max-width: 768px) {
		.menu-container {
			flex-direction: column;
			padding: 1rem;
		}

		.logo {
			margin-bottom: 1rem;
		}

		.menu-items {
			justify-content: center;
			width: 100%;
			gap: 0.75rem;
		}

		.menu-link {
			font-size: 0.9rem;
			padding: 0.4rem 0.6rem;
		}
	}
</style>
